import React from 'react';

interface IMuteIconProps {
  color?: string;
}
const MuteIcon = ({ color = '#fff' }: IMuteIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-mute"
      width="48"
      height="48"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      fill={color}
    >
      <path d="M31 11l-2-2-5 5-5-5-2 2 5 5-5 5 2 2 5-5 5 5 2-2-5-5zM14 5v22h-1l-8-7H1v-8h4l8-7z" />
    </svg>
  );
};

export default MuteIcon;
